<style lang="scss">
.slide-26 {
  background-image: url(../../../assets/module1/slide26/background-01.jpg);
  background-size: cover;
  background-position: center;
  h1 {
    font-size: 74px;
    color: #c5d43b;
    span {
      &:nth-child(2) {
        color: #3b7fc2;
        font-size: 120px;
      }
      &:nth-child(3) {
        transform: rotate(-3deg) translate(315px, -8px);
        display: block;
      }
      &:nth-child(4) {
        transform: rotate(-3deg) translate(401px, -14px);
        display: block;
      }
    }
  }
  .title-wrap {
    right: 390px;
    top: 60px;
    position: absolute;
    display: inline-block;
  }
  p {
    font-size: 32px;
    line-height: 1.4;
    margin-bottom: 35px;
  }
  .content {
    max-width: 705px;
    position: absolute;
    left: 680px;
    top: 373px;
  }
  .right-text {
    margin-top: 50px;
    text-align: right;
  }
  h2 {
    margin-top: 30px;
    color: #edad0a;
    font-size: 50px;
    font-size: 41.9px;
  }
  .highfive {
    position: absolute;
    top: 60px;
    right: 20px;
    width: 350px;
    transition: all 0.2s ease-out;
    z-index: 999;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
  }
  video {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    z-index: 10;
    box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
  }
}
</style>

<template>
  <div class="slide-26">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 25"
        src="@/assets/module1/slide26/high_five.svg"
        class="highfive"
        @click.prevent="play()"
      />
    </transition>
    <transition name="fadeUp" appear>
      <div class="title-wrap delay-2" v-show="slideIndex == 25">
        <h1 v-html="$t('module1.slide26.heading')"></h1>
      </div>
    </transition>
    <div class="content">
      <transition name="fadeUp" appear>
        <div class="delay-3" v-show="slideIndex == 25">
          <p>
            {{ $t("module1.slide26.paragraph") }}
          </p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div class="delay-4" v-show="slideIndex == 25">
          <p>
            {{ $t("module1.slide26.paragraph2") }}
          </p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div class="delay-5" v-show="slideIndex == 25">
          <p>
            {{ $t("module1.slide26.paragraph3") }}
          </p>
        </div>
      </transition>
      <transition name="scale" appear>
        <div v-show="slideIndex == 25" class="delay-6">
          <h2>{{ $t("module1.slide26.heading2") }}</h2>
        </div>
      </transition>
    </div>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 25"
        src="@/assets/module1/slide26/elements.png"
        class="chars delay-4"
      />
    </transition>
    <transition name="fadeLeft" appear>
      <img
        v-show="slideIndex == 25"
        src="@/assets/module1/slide26/timmy-01.png"
        class="chars delay-"
      />
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"],
  data() {
    return {
      showVid: false
    };
  },
  methods: {
    play() {
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    }
  }
};
</script>
